import * as React       from 'react';
import { Outlet, useNavigate, useLocation }       from 'react-router-dom';
import Box              from '@mui/material/Box';
import Toolbar          from '@mui/material/Toolbar';
import TopBar           from 'ui/components/dashboard-components/TopBar';
import LeftDrawer       from 'ui/components/dashboard-components/LeftDrawer';
import { RequireAuth, useAuth }  from 'auth/AuthProvider';
import useActivityTracking from 'hooks/useActivityTracking';

export interface ToggleProps {
    toggleDrawer: () => void
    open: boolean
}

export default function Dashboard(
    props: {drawerOpen?: boolean }
) {
    useActivityTracking();
    const drawerOpen = props.drawerOpen === undefined ? false : props.drawerOpen
    const [bgcolor, setBgcolor] = React.useState('background.paper');
    const [topBarColorLight, setTopBarColorLight] = React.useState('');
    const [topBarColorDark, setTopBarColorDark] = React.useState('')
    const [backButtonProps, setBackButtonProps] = React.useState<{onBack?: () => void, backType?: 'all-reports' | 'school-report'}>({});
    const [open, setOpen] = React.useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { session } = useAuth();
    
    // Redirect users without a name to form-new-teacher
    React.useEffect(() => {
        if (session && (!session.visible_name || session.visible_name.trim() === '')) {
            // Only redirect if not already on form-new-teacher
            if (location.pathname !== '/form-new-teacher') {
                navigate('/form-new-teacher', { replace: true });
            }
        }
    }, [session, navigate, location.pathname]);
    
    const toggleDrawer = () => {
        setOpen(!open);
    };
    return (
        <Box sx={{ display: 'flex', bgcolor: bgcolor }}>
            <TopBar
                toggleDrawer={toggleDrawer}
                open={drawerOpen}
                bgcolorLight={topBarColorLight}
                bgcolorDark={topBarColorDark}
                onBack={backButtonProps.onBack}
                backType={backButtonProps.backType}
            />
            {drawerOpen && <LeftDrawer toggleDrawer={toggleDrawer} open={drawerOpen}/>}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto',
                }}
            >
                <Toolbar />
                <RequireAuth>
                    <Outlet context={{setBgcolor, setTopBarColorLight, setTopBarColorDark, setBackButtonProps}} />
                </RequireAuth>
            </Box>
        </Box>
    );
};

export interface IOutletContext {
    setBgcolor: React.Dispatch<React.SetStateAction<string>>;
    setTopBarColorLight: React.Dispatch<React.SetStateAction<string>>;
    setTopBarColorDark: React.Dispatch<React.SetStateAction<string>>;
    setBackButtonProps: React.Dispatch<React.SetStateAction<{onBack?: () => void, backType?: 'all-reports' | 'school-report'}>>;
};